/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Position_Modal_Line_Position_LabelInputs */



/**
* | output |
* | --- |
* | "Line Position (1-{max})" |
*
* @param {Position_Modal_Line_Position_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_modal_line_position_label = /** @type {((inputs: Position_Modal_Line_Position_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Modal_Line_Position_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Position des lignes (1-${i?.max})`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Linienposition (1-${i?.max})`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Posizione della linea (1-${i?.max})`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Позиция линии (1-${i?.max})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Posición de línea (1-${i?.max})`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`线路位置（1-${i?.max}）`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ラインポジション (1-${i?.max})`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`लाइन स्थिति (1-${i?.max})`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Posição da linha (1-${i?.max})`)
	return /** @type {LocalizedString} */ (`Line Position (1-${i?.max})`)
});